/**
 * External Imports
 */
import { FC } from 'react';

/**
 * Style Imports
 */
import { StartNeuButton } from './Header.styles';

interface StartNewRoundBtnProps {
  disabled: boolean;
  handleStartNewRoundClick?: () => void;
  type: string;
}

const StartNewRoundButton: FC<StartNewRoundBtnProps> = ({
  disabled,
  handleStartNewRoundClick,
  type
}) => {
  return (
    <StartNeuButton
      disabled={disabled}
      size="small"
      onClick={disabled ? undefined : handleStartNewRoundClick}
    >
      Start a New{' '}
      {type === 'validation' ||
      type === 'aidetValidation' ||
      type === 'bssrValidation'
        ? 'Validation'
        : 'Round'}
    </StartNeuButton>
  );
};

export default StartNewRoundButton;
